module.exports = __webpack_public_path__ + "img/no-go-ignition-min.1dc2eb77.jpg";